
import searchCommon from '../modules/search-common';
import global from '../modules/global';
import utils from '../lib/utils';
import tracking from '../lib/tracking';
import { getPartAlertAlternatives, buildAlertEditModal, getDistributors, resetAlertModal } from '../modules/part-alerts';
import common from '../modules/common';
import lookup from '../modules/lookup';
import anchorTabs from '../modules/anchor-tabs';
import customSelect from '../modules/custom-select';
import '../../vendor/jquery.cookie.js';
import '../../vendor/jquery.caret';
import '../../vendor/jquery.numericInput';

common();
lookup();
searchCommon();
customSelect();
anchorTabs();

export default function() {
    if ($('lottie-player').length) {
        import('@lottiefiles/lottie-player');
    }

    if ($('.j-popular-category').length) {
        $('meta[name=keywords]').attr('content', $('meta[name=keywords]').attr('content') + ', ' + $('.j-popular-category').text());
    }

    /**
     * Global SRP object
     * @type {Object}
     */
    window.SRP = {
        filters: {
            exact: false,
            instock: 0,
            manufacturer: ''
        },

        data: {},
        logged: false,
        searchedPart: '',
        getDataDone: false,
        currencies: {},
        manufacturers: {}
    };

    /**
    * Creating data object from distributors tables
    * This should be happen only once
    * @return {[type]} [description]
    */
    let getData = function () {
        if (window.SRP.getDataDone) {
            return true;
        }

        $.each($('.distributor-results, .ab-distributor-results'), function (_i, result) {
            let id = $(result).data('distributoruid');
            let temp = [];
            let searchedPart = window.SRP.searchedPart.toLowerCase();

            $.each($(result).find('tr.row'), function (_idx, item) {

                let exact = ('' + $(item).data('mfrpartnumber')).toLowerCase() === searchedPart,
                    instock = $(item).data('instock'),
                    manufacturer = $(item).find('.td-mfg').text().replace(/^\s+|\s+$/g, '');

                // count manufacturer parts
                if (manufacturer) {
                    if (!window.SRP.manufacturers[manufacturer]) {
                        window.SRP.manufacturers[manufacturer] = 1;
                    } else {
                        window.SRP.manufacturers[manufacturer] += 1;
                    }
                }

                temp.push([exact, instock, $(item), manufacturer]);
            });

            // remove duplicate manufacturers
            for (let manuf in window.SRP.manufacturers) {
                let duplicates = Object.keys(window.SRP.manufacturers).filter(function(item) {
                    return manuf !== item && manuf.toLowerCase() === item.toLowerCase();
                });
                
                if (duplicates.length) {
                    let manufWithMax = manuf;
                    duplicates.reduce(function (max, item) {
                        let currentCount = window.SRP.manufacturers[item];
                        if (currentCount > max) {
                            window.SRP.manufacturers[item] += window.SRP.manufacturers[manufWithMax];
                            delete window.SRP.manufacturers[manufWithMax];
                            manufWithMax = item;
                            return currentCount;
                        } else {
                            window.SRP.manufacturers[manufWithMax] += currentCount;
                            delete window.SRP.manufacturers[item];
                            return max;
                        }
                    }, window.SRP.manufacturers[manuf]);
                }
            }

            window.SRP.data[id] = temp;

        });

        updateAnchorNumber();

        window.SRP.getDataDone = true;

    };

    let initDistributorFilter = function() {
        let $disFilterWrapper = $('.j-distributor-filter');
        let $disFilterSelector = $disFilterWrapper.find('select');
        $.each($('.distributor-results:not(.no-results), .ab-distributor-results'), function (_i, result) {
            let id = $(result).data('distributoruid');
            let name = $(result).data('distributor_name');
            let $disFilterOption = $('<option value="' + id + '">' + name + '</option>');
            $disFilterOption.appendTo($disFilterSelector);
        });
        $disFilterSelector.on('change', function() {
            let value = $disFilterSelector.val();
            if (!value) {
                $('.distributor-results, .ab-distributor-results').removeClass('hide');
                return;
            }
            $.each($('.distributor-results, .ab-distributor-results'), function (_i, result) {
                let id = $(result).data('distributoruid');
                if (id != value) {
                    $(result).addClass('hide');
                } else {
                    $(result).removeClass('hide');
                }
            });
        });
        $disFilterSelector.trigger('change');
    };
    initDistributorFilter();

    /**
    * Filtering data based on user selected filters
    * show/hide rows in tables and update anchors data
    * @return {[type]} [description]
    */
    let filterData = function () {
        getData();

        let numberOfPreferred = 0,
            preferred = window.SRP.preferred || [];

        Object.keys(window.SRP.data).forEach(function (id) {

            let count = 0,
                len = window.SRP.data[id].length,
                data = window.SRP.data[id];

            data.forEach(function (_el, i) {

                let exact = data[i][0],
                    instock = data[i][1],
                    item = data[i][2],
                    manufacturer = data[i][3];

                if (window.SRP.filters.manufacturer) {
                    if (window.SRP.filters.manufacturer.toLowerCase() !== manufacturer.toLowerCase()) {
                        $(item).addClass('hide');
                        count++;
                        return;
                    }
                } else {
                    $(item).removeClass('hide');
                }

                if (window.SRP.filters.exact === false) {
                    if (instock >= window.SRP.filters.instock) {
                        $(item).removeClass('hide');
                    } else {
                        $(item).addClass('hide');
                        count++;
                    }
                } else {
                    if (exact && instock >= window.SRP.filters.instock) {
                        $(item).removeClass('hide');
                    } else {
                        $(item).addClass('hide');
                        count++;
                    }
                }

            });

            // update link in achor tabs
            if (count === len) {
                $('#list' + id).hide();
                disableAnchor(id);
            } else {
                $('#list' + id).show();
                enableAnchor(id);
            }

            if ($.inArray(id, preferred) !== -1) {
                numberOfPreferred += len - count;
            }
        });

        updatePreferredNotice(numberOfPreferred);
        updateAnchorNumber();

    };

    let updatePreferredNotice = function (number) {
        if (!number) {
            $('.j-preferred-noresults').removeClass('hide');
        } else {
            $('.j-preferred-noresults').addClass('hide');
        }
    };

    /**
    * Get number of distributors with results and update anchor number
    * @return {[type]} [description]
    */
    let updateAnchorNumber = function () {
        $.each($('.tabs-content'), function (_i, item) {
            let no = $(item).find('.anchor-link').length,
                group = $(this).attr('id');

            $('#anchors-number-' + group).html('(' + no + ')');

            if (no !== 0 || (!window.FC.user && group === 'preferred-distributors')) {
                $('.anchors-sections a[href="#' + group + '"]').removeClass('disabled');
            } else {
                $('.anchors-sections a[href="#' + group + '"]').addClass('disabled');
            }
        });
    };

    /**
    * all anchors are disabled at start and will be
    * enabled once when data for distributor is loaded
    * @param  {[type]} id distributorUid
    * @return {[type]}    [description]
    */
    let enableAnchor = function (id) {
        let $el = $('#anchorId' + id),
            name = $el.data('name'),
            html = '<a href="#' + id + '" class="anchor-link" data-id="' + id + '">' + name + ' →</a>';
        $el.html(html);
    };

    /**
    * disable anchor by distributoruid
    * @param  {[type]} id distributorUid
    * @return {[type]}    [description]
    */
    let disableAnchor = function (id) {
        let $el = $('#anchorId' + id),
            name = $el.data('name');
        $el.html(name);
    };

    $(function() {
        global();
        tracking.init();

        /**
            Remove scripts from EJS
        */

        $('.j-anchor').each(function() {
            let $this = $(this);
            enableAnchor($this.attr('data-duid'));
        });

        if ($('.j-srp-filters').length) {
            let $filters = $('.j-srp-filters');
            window.SRP.searchedPart = $filters.attr('data-part');
            window.FC.bot = $filters.attr('data-bot');
            window.SRP.preferred = JSON.parse($filters.attr('data-preferred'));

            if ($filters.attr('data-pref-stock') === 'true') {
                window.SRP.filters.instock = 1;
                window.SRP.initFilter = true;
            }
            if ($filters.attr('data-pref-match') === 'true') {
                window.SRP.filters.exact = true;
                window.SRP.initFilter = true;
            }
        }

        window.SRP.filters.manufacturer = $('#manufacturers-select-holder').attr('data-manuf');

        $('#currencySort').selectOverlap();
        $('#currencySort').removeClass('hide');
        $('.temp-currency-filter-holder').remove();
        $('#currencySort').parent('.select-holder').css('display', 'inline-block');
        $('#j-search-onboarding-modal').popup('show');

        getData();

        // Manufacturer Impression Tracking
        // and select for filter
        let manufacturersSelect = $('#manufacturers-select-holder select');
        $('<option />', {
            value: 'Select Manufacturer',
            text: 'Select Manufacturer',
            selected: true
        }).appendTo(manufacturersSelect);

        let selectedManufacturer = $('#manufacturers-select-holder').attr('data-manuf');
        if (selectedManufacturer && !Object.keys(window.SRP.manufacturers).includes(selectedManufacturer)) {
            $('<option />', {
                value: selectedManufacturer,
                text: selectedManufacturer + ' (Not Found)',
                selected: true
            }).appendTo(manufacturersSelect);
        }

        for (let i in window.SRP.manufacturers) {
            if (i) {
                $('<option />', {
                    value: i,
                    text: i,
                    selected: i === window.SRP.filters.manufacturer
                }).appendTo(manufacturersSelect);
            }
        }

        $('#manufacturers-select-holder .select-holder').remove();
        $('#manufacturers-select-holder select').removeClass('hide');
        $('#manufacturers-select-holder select').customSelectOverlay();

        $(manufacturersSelect).on('change', function () {
            if (this.value === 'Select Manufacturer') {
                window.location = utils.queryParam(window.location.href, 'manufacturer', null);
            } else {
                window.location = utils.queryParam(window.location.href, 'manufacturer', this.value);
            }
        });

        $('.manufacturer-filter-holder .hyperlink:not(.icon-close)').on('click', function () {
            window.location = utils.queryParam(window.location.href, 'manufacturer', null);
        });

        if (selectedManufacturer && $('.distributor-results .row:visible').length === 0 && $('.distributor-results .row').length) {
            let $insertBefore = $('.associated-parts').length ? $('.associated-parts:first') : $('.footer');
            let $noResults = $('<p class="no-results"></p>');
            $noResults.text(`No ${window.SRP.searchedPart} results were found with the manufacturer filter applied for ${selectedManufacturer}.`);
            $noResults.insertBefore($insertBefore);
            let $noResultsTitle = $('<h2 class="manufacturer-no-results-title"></h2>');
            $noResultsTitle.text(`${window.SRP.searchedPart} Availability from other manufacturers`);
            $noResultsTitle.insertBefore($insertBefore);
            let $results = $('.distributor-results');
            $results.removeClass('no-results');
            $results.find('.row').css('display', 'revert');
            $results.insertBefore($insertBefore);
            window.SRP.filters.manufacturer = null;
            filterData();
        }

        // srp show filters - mobile
        $('.j-show-filters').on('click', function () {
            $('.j-filters').toggleClass('hide');
            if ($('.j-filters').hasClass('hide')) {
                $('.j-show-filters').text('Show Filters');
            } else {
                $('.j-show-filters').text('Hide Filters');
            }
        });

        $(window).on('resize', function() {
            let $dropdown = $('.manufacturer-filter-holder .j-custom-option-list');
            if ($dropdown.css('position') === 'fixed' && !$dropdown.hasClass('hide') && $('.j-filters').hasClass('hide')) {
                $('.j-show-filters').trigger('click');
            }
        });

        $('#filterInStockInput').on('input', function (e) {
            if ($(this).val().startsWith('0')) {
                $(this).val($(this).val().replace(/^0+/, ''));
            }

            let val = Math.abs(parseInt($(this).val().replace(/,/g, ''), 10));
            $('#filterInStockInput').val(val);

            if (val) {
                window.SRP.filters.instock = val;
                $('#filterInStock').prop('checked', true);
                filterData();
            } else {
                $('#filterInStock').prop('checked', false);
                window.SRP.filters.instock = 0;
                filterData();
            }
        });

        $('#filterInStockInput').on('blur', function () {
            tracking.ckEvent('stockBox', 'FCfull_SRP_' + window.FC.ipSite, null, null, null, 'query=' + window.SRP.searchedPart + '|quantity=' + utils.numericOnly($(this).val()));
        });

        $('#filterInStock').on('change', function () {

            let csrf = $(this).data('csrf');

            if ($(this).prop('checked')) {
                window.SRP.filters.instock = 1;
                tracking.ckEventUrl($(this).attr('data-yes'));
            } else {
                window.SRP.filters.instock = 0;
                tracking.ckEventUrl($(this).attr('data-no'));
            }

            $('#filterInStockInput').val(window.SRP.filters.instock == 0 ? '' : window.SRP.filters.instock);

            filterData();

            updatePreferences({
                _csrf: csrf,
                pref_in_stock: Boolean(window.SRP.filters.instock)
            });
        });

        $('#filterExactMatches').on('change', function () {

            let csrf = $(this).data('csrf');

            if ($(this).prop('checked')) {
                window.SRP.filters.exact = true;
                tracking.ckEventUrl($(this).attr('data-yes'));
            } else {
                window.SRP.filters.exact = false;
                tracking.ckEventUrl($(this).attr('data-no'));
            }
            filterData();

            updatePreferences({
                _csrf: csrf,
                pref_exact_match: window.SRP.filters.exact
            });
        });

        /**
         * currency estimator change
         * @TODO calculate proper price for non-tired (http://localhost:1337/avail?part=bav99#1538)
         * @return {[type]} [description]
         */
        $('#currencySort').on('change', function () {

            let newCode = $(this).val(),
                csrf = $(this).data('csrf');

            tracking.ckEventUrl($(this).attr('data-url'));

            updatePreferences({
                _csrf: csrf,
                pref_currency: newCode
            }, null, function () {
                if (newCode !== 'default') {
                    window.location = utils.queryParam(window.location.href, 'currency', newCode);
                } else {
                    window.location = utils.queryParam(window.location.href, 'currency', null);
                }
            });

        });

        $('#filterInStockInput').numericInput({init: true, addcommas: true});

        if (window.SRP.initFilter) {
            filterData();
        }

        // for change before JS load
        if ($('#filterInStock').is(':checked').toString() !== $('#filterInStock').attr('data-default')) {
            $('#filterInStock').change();
        }
        if ($('#filterExactMatches').is(':checked').toString() !== $('#filterExactMatches').attr('data-default')) {
            $('#filterExactMatches').change();
        }

        // anchors click
        $('.content').on('click', '.tabs-content li a', function (e) {

            e.preventDefault();

            let id = $(this).data('id'),
                $target = $('#list' + id);
            let $header = $('#header').length ? $('#header') : $('.header');

            $(window).scrollTop($target.offset().top - $header.outerHeight());

            $(this).closest('.tabs-content').hide();
            $('.anchors-sections a').removeClass('active');
            // tracking
            let tab = $(this).parent().parent().parent().attr('id'),
                distributorName = $(this).text(),
                gaCategory = 'Anchors',
                gaLabel = 'NAME',
                gaAction = distributorName;

            if (tab === 'preferred-distributors') {
                gaCategory = 'mypreferreddisti';
                gaAction = 'preferredanchor';
                gaLabel = distributorName;
            }

            tracking.ckEventUrl($(this).parents('li').attr('data-url'));
            tracking.recordUserClick(gaCategory, gaAction, gaLabel);
        });

        $(document).on('click', function (e) {
            let $target = $('.tabs-content');

            if ($('.tabs-content').has(e.target).length || $('.anchors-sections').has(e.target).length) {
                return;
            }
            $('.anchors-sections a').removeClass('active');
            $target.hide();
        });
        
        let $currency = $('.j-currency-sort-holder');
        let $currencySorter = $('.j-currency-sorter');
        let headerHeight = $('#header').length ? $('#header').outerHeight() : $('.header').outerHeight();
        let $selectHolder = $currency.find('.j-select-holder');

        if ($currencySorter.length && $currency.length) {
            let selectOffset = $selectHolder.offset().top;
            let selectHeight = $selectHolder.outerHeight();
            let $prev = $currency.prev();
            let inHead = false;
            if (utils.checkScreenSize('<=', 'tablet')) { // always display in header for mobile
                $currencySorter.show();
                $currency.appendTo($currencySorter);
                inHead = true;
            }

            $(window).on('scroll', function () {
                if ($(document).scrollTop() >= (selectOffset + selectHeight - headerHeight)) {
                    if (inHead) {
                        return;
                    }
                    $currencySorter.show();
                    $currency.appendTo($currencySorter);
                    inHead = true;
                } else {
                    if (!inHead) {
                        return;
                    }
                    $currency.insertAfter($prev);
                    $currencySorter.hide();
                    inHead = false;
                }
            });
        }

        $('.back-to-top').on('click', function() {
            tracking.ckEventUrl($(this).attr('data-url'));
            tracking.recordUserClick('Anchors', $(this).attr('data-name'), 'TOP');
        });

        let $partAlertModal = $('.part-alerts-modal');
        if (!(window.SRP.filters.manufacturer in window.SRP.manufacturers)) {
            let $manufacturerSection = $('.manufacturer-section');
            let alertManufacturersSelect = $('.alert-manufacturers-select-holder select');
            $('<option />', {
                value: 'Select Manufacturer',
                text: 'Select Manufacturer',
                selected: true
            }).appendTo(alertManufacturersSelect);

            for (let i in window.SRP.manufacturers) {
                if (i) {
                    $('<option />', {
                        value: i,
                        text: i
                    }).appendTo(alertManufacturersSelect);
                }
            }
            $('.alert-manufacturers-select-holder select').customSelectOverlay();

            $(alertManufacturersSelect).on('change', function () {
                let manuf = this.value;
                if (manuf === 'Select Manufacturer') {
                    resetAlertModal($partAlertModal);
                    $partAlertModal.find('input.j-manufacturer').val('');
                    $partAlertModal.find('span.j-manufacturer').text('');
                    $('.j-part-alert-form-error').addClass('hide');
                    $partAlertModal.find('.pricing-section, .inventory-section, .j-alerts-next, .j-confirm-btn').addClass('is-disabled');
                    $partAlertModal.find('.j-alert-checkbox').prop('checked', false).trigger('change');
                } else {
                    $('.j-part-alert-form-error').addClass('hide');
                    $partAlertModal.find('.pricing-section, .inventory-section').removeClass('is-disabled');
                    $partAlertModal.find('.j-alerts-next, .j-confirm-btn').addClass('is-disabled');
                    getPartAlertAlternatives(window.SRP.searchedPart, manuf, true);

                    let alertData = {
                        default: true
                    };

                    let checkUserData = $manufacturerSection.data('user') == true ? 
                        $.ajax({
                            url: '/account/getAlerts',
                            method: 'POST',
                            data: {
                                part: window.SRP.searchedPart,
                                mfr: manuf,
                                _csrf: window.FC.csrf
                            },
                            success: function(data) {
                                alertData = data.data ? data.data : alertData;
                            }
                        }) : $.Deferred().resolve();
                    
                    checkUserData.always(function() {
                        $.ajax({
                            url: '/ajax/fcData',
                            method: 'POST',
                            data: {
                                part: window.SRP.searchedPart,
                                mfr: manuf,
                                _csrf: window.FC.csrf
                            },
                            success: function (responseData) {
                                if (responseData.err) {
                                    return;
                                }
                                $partAlertModal.find('.j-pricing-alert').attr('data-have-price', responseData.hasPrice ? 'true' : 'false');
                            }
                        }).always(function() {
                            alertData.manufacturer = manuf;
                            buildAlertEditModal($partAlertModal, alertData);
                            if (alertData.default) {
                                if ($partAlertModal.find('.j-alert-limit-error').length) {
                                    $partAlertModal.find('.j-alert-limit-error').removeClass('hide');
                                    $partAlertModal.find('.j-alerts-next').addClass('disabled');
                                    $partAlertModal.find('.j-alerts-next').prop('disabled', true);
                                }
                                $partAlertModal.find('.update-alert').addClass('hide');
                                $partAlertModal.find('.insert-alert').removeClass('hide');
                                $partAlertModal.find('.j-pricing-alert-expire-select option[value=0]').remove();
                            } else {
                                if ($partAlertModal.find('.j-alert-limit-error').length) {
                                    $partAlertModal.find('.j-alert-limit-error').addClass('hide');
                                    $partAlertModal.find('.j-alerts-next').removeClass('disabled');
                                    $partAlertModal.find('.j-alerts-next').prop('disabled', false);
                                }
                                $partAlertModal.find('.update-alert').removeClass('hide');
                                $partAlertModal.find('.insert-alert').addClass('hide');
                                $partAlertModal.find('.j-pricing-alert-expire-select').prepend($('<option>', {
                                    value: 0,
                                    text: 'now'
                                }));
                                $partAlertModal.find('.j-pricing-alert-expire-select option[value=0]').prop('selected', true);
                            }
                            $partAlertModal.find('.j-alerts-next, .j-confirm-btn').removeClass('is-disabled');
                        });
                    });
                }
            });

            $manufacturerSection.removeClass('hide');
            resetAlertModal($partAlertModal);
            $partAlertModal.find('.pricing-section, .inventory-section, .j-alerts-next').addClass('is-disabled');
            $partAlertModal.find('.j-alert-checkbox').prop('checked', false).trigger('change');
        } else {
            getPartAlertAlternatives(window.SRP.searchedPart, window.SRP.filters.manufacturer, true);
            
            let pricing = false;
            Object.keys(window.SRP.data).forEach(function (id) {
                let data = window.SRP.data[id];
                for (let item of data) {
                    let exact = item[0];
                    let manufacturer = item[3];

                    if (exact && window.SRP.filters.manufacturer == manufacturer) {
                        pricing = true;
                        return;
                    }    
                }
            });
            $partAlertModal.find('.j-pricing-alert').attr('data-have-price', pricing ? 'true' : 'false');

            if (window.FC.alert) {
                $partAlertModal.find('.update-alert').removeClass('hide');
                $partAlertModal.find('.insert-alert').addClass('hide');
                $partAlertModal.find('.j-pricing-alert-expire-select').prepend($('<option>', {
                    value: 0,
                    text: 'now'
                }));
                $partAlertModal.find('.j-pricing-alert-expire-select option[value=0]').prop('selected', true);
                buildAlertEditModal($partAlertModal, {
                    settings: window.FC.alert.settings
                });
            } else {
                buildAlertEditModal($partAlertModal, {
                    default: true
                });
                if ($partAlertModal.find('.j-alert-limit-error').length) {
                    $partAlertModal.find('.j-alert-limit-error').removeClass('hide');
                    $partAlertModal.find('.j-alerts-next').addClass('disabled');
                    $partAlertModal.find('.j-alerts-next').prop('disabled', true);
                }
            }
        }

        let initDistributors = false;
        $('.alert-btn').on('click', function() {
            if (!initDistributors) {
                getDistributors();
                initDistributors = true;
            }
            
            $('#partAlertModal').popup('show');
            setTimeout(function() {
                $($('#partAlertModal .j-alert-settings input[type!=hidden]')[0]).trigger('focus'); // focus on first non-hidden input
            }, 500);
        });

        const idBnls = [
            { id: 'bnl1', $el: $('#list_spons_5') },
            { id: 'bnl2', $el: $('#secondary-bnl') },
            { id: 'bnl3', $el: $('#list_spons_3') },
        ];
        const $hoverCandidates = $('#secondary-bnl ~ div [data-id]:visible');
        const fcsah = window.FC.sah = {
            triggerLimit: 5,
            timerId: null,
            activeId: null,
            activeType: null,
        };
        let rowsToListen = 20;

        setBnlListeners(idBnls, fcsah, rowsToListen);
        if (idBnls.every(({ id }) => !fcsah[id]?.mfr)) {
            // bnls not rendered yet at document.ready
            const handler = () => setBnlListeners(idBnls, fcsah, rowsToListen);
            idBnls.forEach(({ $el }) => $el.one('mouseenter', handler));
        }

        for (const el of $hoverCandidates) {
            if (rowsToListen === 0) {
                break;
            }

            const $el = $(el);

            const elDataId = $el.attr('data-id');
            if ($el.attr('data-sa-event-element') === 'logo') {
                fcsah[elDataId] = {
                    triggers: [0, 0, 0],
                    dist: $el.attr('data-distributor_name'),
                };

                $el.on('mouseenter', mouseEnterHandler)
                    .on('mouseleave', mouseLeaveHandler);
                continue;
            }

            fcsah[elDataId] = {
                triggers: [0, 0, 0],
                mfr: $el.attr('data-mfr'),
                pn: $el.attr('data-mfrpartnumber'),
                stock: $el.attr('data-stock') ?? $el.attr('data-instock'),
                price: $el.attr('data-price'),
            };

            $el.find('.j-sa-event')
                .on('mouseenter', mouseEnterHandler)
                .on('mouseleave', mouseLeaveHandler);

            rowsToListen--;
        }
    });

    /**
    * Update user and cookie
    * @param  {[type]} data [description]
    * @return {[type]}      [description]
    */
    function updatePreferences(data, beforeCallback, afterCallback) {

        if (typeof beforeCallback === 'undefined') {
            beforeCallback = new Function;
        }

        if (typeof afterCallback === 'undefined') {
            afterCallback = new Function;
        }

        // update user preferences if user is logged in
        if (window.FC.user) {
            $.ajax({
                url: '/account/updatePreferences',
                type: 'POST',
                dataType: 'json',
                data: data,
                beforeSend: beforeCallback,
                complete: afterCallback,
                error: function () {
                    if (window.console) {
                        console.log('error update preferences');
                    }
                }
            });
        }

        let cookie = $.cookie('fc_user') || '{}';

        cookie = JSON.parse(cookie);
        for (let i in data) {
            if (i !== '_csrf') {
                cookie[i] = data[i];
            }
        }

        $.cookie('fc_user', JSON.stringify(cookie));

        // in case that user is not registered
        if (!window.FC.user) {
            afterCallback();
        }
    }

    function setBnlListeners(idBnls, fcsah, rowsToListen) {
        if (!Array.isArray(idBnls)) {
            return;
        }

        if (idBnls.every(({ id }) => fcsah[id]?.mfr)) {
            return;
        }

        for (const bnl of idBnls) {
            if (!bnl.$el.length) {
                continue;
            }

            const $row = bnl.$el.find('.row');
            fcsah[bnl.id] = {
                triggers: [0, 0, 0],
                dist: $row.attr('data-distributor_name'),
                mfr: $row.find('.mfrName').text(),
                pn: $row.attr('data-mfrpartnumber'),
                stock: $row.attr('data-instock'),
                price: $row.find('.mfrPrice .table-list').text(),
            };

            const selectors = [
                '.bnl-distributor-logo',
                '.buy-now-click-tracking[data-click-name="part number"]',
                '.buy-now-click-tracking[data-click-name="buy"]',
            ];
            for (const selector of selectors) {
                bnl.$el.find(selector)
                    .on('mouseenter', getBnlMouseEnterHandler(bnl.id))
                    .on('mouseleave', mouseLeaveHandler);
            }

            rowsToListen--;
        }
    }

    function getBnlMouseEnterHandler(bnlId) {
        return function() {
            if (!window.FC.sah) {
                return;
            }

            const { sah } = window.FC;
            sah.activeId = bnlId;
            sah.activeType = getHoverElementType($(this));

            mouseEnterHandler();
        };
    }

    const hoverElement = { logo: 0, mpn: 1, bnl: 2 };

    function getHoverElementType($el) {
        if ($el.attr('data-sa-event-element')) {
            return {
                isSponsor: false,
                element: hoverElement[$el.attr('data-sa-event-element')],
            };
        }
        if ($el.hasClass('buy-now-click-tracking')) {
            if ($el.attr('data-click-name') === 'part number') {
                return {
                    isSponsor: true,
                    element: hoverElement.mpn,
                };
            }
            if ($el.attr('data-click-name') === 'buy') {
                return {
                    isSponsor: true,
                    element: hoverElement.bnl,
                };
            }
        }
        if ($el.hasClass('bnl-distributor-logo')) {
            return {
                isSponsor: true,
                element: hoverElement.logo,
            };
        }
        return null;
    }

    function mouseEnterHandler() {
        const { sah } = window.FC;
        const $this = $(this);
        const hoverId = $this.attr('data-id') ?? $this.attr('data-row-id');
        if (!sah.activeId && hoverId) {
            sah.activeId = hoverId;
            sah.activeType = getHoverElementType($this);
        }

        if (sah[sah.activeId].triggers[sah.activeType.element] < sah.triggerLimit) {
            sah.timerId = window.setInterval(triggerHandler, 3000);
        }
    }

    function mouseLeaveHandler() {
        const { sah } = window.FC;
        if (!sah) {
            return;
        }

        sah.activeId = null;
        sah.activeType = null;
        const timerId = sah.timerId;
        if (!timerId) {
            return;
        }

        clearInterval(timerId);
        sah.timerId = null;
    }

    function triggerHandler() {
        const { sah } = window.FC;

        if (!sah.activeId) {
            return;
        }

        const sahActive = sah[sah.activeId];

        if (sahActive.triggers[sah.activeType.element] === sah.triggerLimit) {
            return;
        }

        sahActive.triggers[sah.activeType.element]++;
        const dataLayer = window.dataLayer || [];
        dataLayer.push(getEvent(sahActive, sah.activeType));
    }

    function getEvent(sahActive, activeType) {
        const sponsorPrefix = activeType.isSponsor ? 'sponsor-' : '';
        const type = ['logo', 'mpn', 'bnl'][activeType.element];
        const baseEvent = {
            event: 'sa_hover',
            element_type: `${sponsorPrefix}${type}`,
        };

        if (activeType.element === hoverElement.logo) {
            return {
                ...baseEvent,
                distributor: sahActive.dist,
            };
        }

        return {
            ...baseEvent,
            part_number: sahActive.pn,
            manufacturer: sahActive.mfr,
            stock: sahActive.stock,
            price: sahActive.price,
        };
    }
}
